var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('intro',{attrs:{"id":"intro"}}),_c('about-us',{attrs:{"id":"about"}}),_c('product-list',{attrs:{"id":"product"}}),_c('mask-pro'),_c('contact-us',{attrs:{"id":"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }